var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserSummaryPopover',{attrs:{"account":_vm.account}},[_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(`${_vm.getFullName(_vm.account)} `))])])
}
var staticRenderFns = []

export { render, staticRenderFns }